import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalComponent } from '../shared/modal/modal.component';
import { BatchDeclineSummary } from '../model/batch-decline';
import { DeclineItemListComponent } from '../decline-item-list/decline-item-list.component';

@Component({
  selector: 'decline-success',
  standalone: true,
  imports: [CommonModule, ModalComponent, DeclineItemListComponent],
  templateUrl: './decline-success.component.html',
  styleUrl: './decline-success.component.scss',
})
export class DeclineSuccessComponent {
  @Input() active: boolean = false;
  @Input() isFixedPrice: boolean = false;
  @Input() isAtp: boolean = false;
  @Input() batch: BatchDeclineSummary | null = null;
  @Output() modalClosed = new EventEmitter<boolean>();

  @Input() address: any = { streetAddress: '', cityStateZip: '' };

  get hasBatchIssues(): boolean {
    return !!(this.batch?.failed.length || this.batch?.skipped.length);
  }

  closeDialog() {
    // Visibility is the parent's, per `app-modal`'s contract that `(close)`
    // only signals intent. Assigning `this.active = false` here desynchronized
    // this component from the binding: Angular still held `true` as the last
    // value it wrote, so re-emitting `true` for a queued batch summary was not
    // a change and the dialog never reopened.
    this.modalClosed.emit(false);
  }
  submit() {
    this.closeDialog();
  }
}
